export const EM_CONTENT = {
  hero: {
    kicker: 'Para indústrias, locadoras e construtoras',
    title: 'Quanto custa cada equipamento parado esperando uma manutenção que devia ter sido feita antes?',
    subtitle:
      'Tenha o inventário completo dos seus equipamentos, abra ordens de manutenção preventiva e corretiva, e nunca mais perca o histórico de reparo de uma máquina.',
    cta: 'Quero controlar minhas manutenções',
    ctaMessage: 'Quero conhecer o controle de manutenção de equipamentos do 77Gestão',
    urgency: 'Cada dia sem controle é um equipamento a mais correndo o risco de quebrar no pior momento.',
  },

  statsStrip: [
    { number: '100%', label: 'dos equipamentos com histórico completo', icon: 'fa-solid fa-toolbox' },
    { number: 'Zero', label: 'manutenções esquecidas', icon: 'fa-solid fa-bell' },
    { number: '1 lugar', label: 'para gerenciar toda a manutenção', icon: 'fa-solid fa-clipboard-list' },
  ],

  pain: {
    title: 'Reconhece esses problemas na gestão dos seus equipamentos?',
    intro:
      'Indústrias, locadoras e obras convivem com máquinas paradas e prejuízo evitável — não por falta de cuidado, mas por falta de um sistema que organize a manutenção.',
    items: [
      { icon: 'fa-solid fa-triangle-exclamation', text: 'Manutenção preventiva é esquecida até o equipamento quebrar no momento mais crítico da operação.' },
      { icon: 'fa-regular fa-clock', text: 'Equipamento parado gerando prejuízo enquanto se espera peça, mecânico ou decisão.' },
      { icon: 'fa-solid fa-file-circle-question', text: 'Nenhum histórico de reparo por equipamento — cada problema é tratado como se fosse a primeira vez.' },
      { icon: 'fa-solid fa-people-arrows', text: 'Times diferentes não sabem o estado real de cada máquina ou ferramenta da empresa.' },
      { icon: 'fa-solid fa-list-check', text: 'Sem controle de quais equipamentos existem, onde estão e quando foram revisados pela última vez.' },
    ],
  },

  midCta: {
    text: 'E se toda manutenção preventiva acontecesse antes da máquina parar, não depois?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do controle de manutenção de equipamentos do 77Gestão',
  },

  solution: {
    title: 'Manutenção organizada, sem depender da memória de ninguém',
    intro:
      'O módulo de equipamentos do 77Gestão dá visibilidade total sobre suas máquinas e ferramentas, do cadastro à ordem de serviço.',
    cards: [
      {
        icon: 'fa-solid fa-boxes-stacked',
        title: 'Inventário completo de equipamentos',
        text: 'Cadastre máquinas, ferramentas e ativos com todas as informações relevantes centralizadas em um só lugar.',
      },
      {
        icon: 'fa-solid fa-clipboard-check',
        title: 'Ordens de manutenção preventiva',
        text: 'Abra ordens de manutenção programada para cada equipamento e evite que o problema apareça na pior hora.',
      },
      {
        icon: 'fa-solid fa-screwdriver-wrench',
        title: 'Ordens de manutenção corretiva',
        text: 'Registre reparos não programados com todos os detalhes: o que quebrou, o que foi feito e quem executou.',
      },
      {
        icon: 'fa-solid fa-clock-rotate-left',
        title: 'Histórico por equipamento',
        text: 'Cada máquina tem seu próprio histórico de manutenção, disponível para consulta a qualquer momento.',
      },
      {
        icon: 'fa-solid fa-layer-group',
        title: 'Visão geral da operação',
        text: 'Enxergue de forma centralizada o estado de todos os equipamentos, sem depender de planilha ou caderno de oficina.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a manutenção deixa de ser reativa',
    intro:
      'Uma empresa com maquinário próprio na operação só percebia que um equipamento precisava de manutenção quando ele já tinha parado de funcionar.',
    stats: [
      { number: '0', label: 'quebras por manutenção esquecida' },
      { number: '100%', label: 'dos equipamentos com histórico completo' },
      { number: '2x', label: 'mais rápido para abrir uma ordem de manutenção' },
    ],
    paragraphs: [
      'Depois de cadastrar o inventário e passar a abrir ordens de manutenção preventiva pelo sistema, a equipe passou a agir antes do problema aparecer.',
      'O histórico completo por equipamento também eliminou o retrabalho de diagnóstico: qualquer técnico consulta o que já foi feito antes de iniciar um novo reparo.',
    ],
    highlight: 'Resultado: menos equipamento parado, menos prejuízo e manutenção sob controle.',
    cta: 'Quero esse controle nos meus equipamentos',
    ctaMessage: 'Vi o resultado e quero controlar a manutenção dos meus equipamentos com o 77Gestão',
  },

  benefits: {
    title: 'Os três pilares do controle de manutenção',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Saiba o estado de cada equipamento e o que já foi feito nele, sem depender de quem lembra.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Toda ordem de manutenção, preventiva ou corretiva, registrada no equipamento certo.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Manutenção preventiva programada evita que o equipamento pare no meio da operação.',
      },
    ],
  },

  differentials: {
    title: 'Por que indústrias e locadoras escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Sistema simples, que se adapta a qualquer quantidade e tipo de equipamento da sua operação.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada para cadastrar seu inventário e organizar as primeiras ordens de manutenção.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado, sempre disponível quando você precisar.' },
      { icon: 'fa-solid fa-link', text: 'Equipamentos integrados ao restante do 77Gestão, sem sistema separado para gerenciar.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Minha empresa tem poucos equipamentos, vale a pena?',
        answer:
          'Vale. Mesmo com um inventário pequeno, ter o histórico de manutenção evita quebras evitáveis e prejuízo com equipamento parado. O sistema se adapta ao tamanho da sua operação.',
      },
      {
        question: 'O sistema controla manutenção preventiva e corretiva?',
        answer:
          'Sim. Você pode abrir ordens de manutenção preventiva, programadas com antecedência, e ordens corretivas para reparos não programados — ambas ficam registradas no histórico do equipamento.',
      },
      {
        question: 'Preciso trocar de sistema de gestão para usar isso?',
        answer:
          'Não. O módulo de equipamentos faz parte do 77Gestão, o mesmo sistema que já cuida do financeiro, estoque e demais áreas da empresa.',
      },
      {
        question: 'Como funciona a implantação?',
        answer:
          'A equipe acompanha o cadastro do seu inventário de equipamentos e a configuração das primeiras ordens de manutenção, para que sua operação comece a usar o sistema sem parar.',
      },
      {
        question: 'O sistema avisa quando uma manutenção preventiva está próxima?',
        answer:
          'Sim, a manutenção preventiva é programada dentro do sistema e fica visível para a equipe agir antes que o equipamento precise parar por quebra.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de deixar a manutenção para depois que o equipamento já quebrou.',
    subtitle:
      'Agende uma demonstração e veja como organizar o inventário e as ordens de manutenção da sua empresa.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do controle de manutenção de equipamentos do 77Gestão',
  },

  seo: {
    title: 'Sistema de Controle de Manutenção de Equipamentos | 77Gestão',
    description:
      'Gestão de manutenção de máquinas com inventário completo, ordens preventivas e corretivas e histórico por equipamento. Agende uma demonstração gratuita.',
  },
};
